function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#1CA2E1",
  fillRule: "evenodd",
  d: "M.335 4.33a1.155 1.155 0 011.602-.014l.014.014L8 10.284l6.049-5.954a1.155 1.155 0 011.602-.014l.014.014c.442.434.447 1.136.014 1.577l-.014.013-6.857 6.75a1.155 1.155 0 01-1.602.014l-.014-.014L.335 5.92a1.11 1.11 0 010-1.59z"
});

var SvgArrowDown = function SvgArrowDown(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 16
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2Ij4KICAgIDxwYXRoIGZpbGw9IiMxQ0EyRTEiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTS4zMzUgNC4zM2MuNDQxLS40MzUgMS4xNTUtLjQ0IDEuNjAyLS4wMTRsLjAxNC4wMTRMOCAxMC4yODRsNi4wNDktNS45NTRjLjQ0Mi0uNDM1IDEuMTU1LS40NCAxLjYwMi0uMDE0bC4wMTQuMDE0Yy40NDIuNDM0LjQ0NyAxLjEzNi4wMTQgMS41NzdsLS4wMTQuMDEzLTYuODU3IDYuNzVjLS40NDIuNDM1LTEuMTU1LjQ0LTEuNjAyLjAxNGwtLjAxNC0uMDE0TC4zMzUgNS45MmMtLjQ0Ny0uNDM5LS40NDctMS4xNTEgMC0xLjU5eiIvPgo8L3N2Zz4K";
export { SvgArrowDown as ReactComponent };